import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { AccountsOverzicht } from '@fleet/shared';
import { api } from '../../lib/apiClient';

/** Elke mutatie geeft het verse overzicht terug, dus die zetten we direct in de
 *  cache in plaats van een extra ronde langs de server te doen. */
function useOverzichtMutatie<TInput>(fn: (input: TInput) => Promise<AccountsOverzicht>) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: (data) => qc.setQueryData(['accounts'], data),
  });
}

export function useAccounts() {
  return useQuery({
    queryKey: ['accounts'],
    queryFn: () => api.get<AccountsOverzicht>('/accounts'),
  });
}

export function useNodigUit() {
  return useOverzichtMutatie((email: string) =>
    api.post<AccountsOverzicht>('/accounts/uitnodigingen', { email }),
  );
}

export function useStuurOpnieuw() {
  return useOverzichtMutatie((id: string) =>
    api.post<AccountsOverzicht>(`/accounts/uitnodigingen/${id}/opnieuw`),
  );
}

export function useTrekIn() {
  return useOverzichtMutatie((id: string) =>
    api.del<AccountsOverzicht>(`/accounts/uitnodigingen/${id}`),
  );
}

export function useVerwijderAccount() {
  return useOverzichtMutatie((id: string) => api.del<AccountsOverzicht>(`/accounts/${id}`));
}
